import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import traduceri
import commonRO from './locales/ro/common.json';
import commonEN from './locales/en/common.json';
import homeRO from './locales/ro/home.json';
import homeEN from './locales/en/home.json';
import aboutRO from './locales/ro/about.json';
import aboutEN from './locales/en/about.json';
import processRO from './locales/ro/process.json';
import processEN from './locales/en/process.json';
import contactRO from './locales/ro/contact.json';
import contactEN from './locales/en/contact.json';

// Resurse de traducere
const resources = {
  ro: {
    common: commonRO,
    home: homeRO,
    about: aboutRO,
    process: processRO,
    contact: contactRO
  },
  en: {
    common: commonEN,
    home: homeEN,
    about: aboutEN,
    process: processEN,
    contact: contactEN
  }
};

i18n
  // Detectează limba din browser/localStorage
  .use(LanguageDetector)
  // Integrare React
  .use(initReactI18next)
  // Configurare
  .init({
    resources,
    lng: 'ro', // Limba inițială forțată
    fallbackLng: 'ro', // Limba default
    defaultNS: 'common', // Namespace default
    
    // Detectare limbă
    detection: {
      order: ['localStorage', 'navigator'], // Verifică localStorage, apoi browser
      caches: ['localStorage'], // Salvează în localStorage
      lookupLocalStorage: 'i18nextLng'
    },
    
    // Interpolation
    interpolation: {
      escapeValue: false // React face escape automat
    },
    
    // Debug (dezactivat în producție)
    debug: process.env.NODE_ENV === 'development'
  });

export default i18n;
